import React, { useEffect, useState } from "react";
import Loader from "../components/common/loader/loader";
import { useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import Error from "../components/common/error/error";
import { notify } from "../lib/utils";
import usePageTitle from "../hooks/usePageTitle";
import { createSet, getSetById, updateSet } from "../api/admin/sets";
import CreateUpdateSetForm from "../components/sets/create-update-set-form";

function SetFormPage() {
  const params = useParams();
  const navigate = useNavigate();

  const [set, setSet] = useState<any>(null);

  const [isEditMode, setIsEditMode] = useState(false);

  usePageTitle(isEditMode ? `Edit Set: ${set?.internalName}` : "Create Set");

  const [loading, setLoading] = React.useState(true);

  const [btnLoading, setBtnLoading] = React.useState(false); // when saving

  const [error, setError] = React.useState<any>(false);

  const loadSetById = async (id: string) => {
    // fetch the template by id
    const response = await getSetById(id);

    if (!response || response.status !== 200) {
      setError("Error loading Set");
      setLoading(false);
      setIsEditMode(false);
      return;
    }

    setIsEditMode(true);
    setSet(response.data);
    setError(null);
    setLoading(false);
  };

  useEffect(() => {
    if (params.id) {
      loadSetById(params.id);
    } else {
      setIsEditMode(false);
      setLoading(false);
      setError(false);
    }
    // reset the state when unmounting

    return () => {
      setSet(null);
      setLoading(false);
      setError(false);
      setIsEditMode(false);
      setBtnLoading(false);
    };
  }, []);

  // handle category creation
  const handleCreateSet = async ({ setData }: any) => {
    // merge them in object.

    const response = await createSet(setData);

    if (!response || response.status !== 201) {
      // check slug duplication
      if (response?.status === 409) {
        notify({
          type: "error",
          message: "Set already exists with the same slug",
        });
      } else {
        notify({
          type: "error",
          message: "Error creating set",
        });
      }

      return;
    }

    notify({
      type: "success",
      message: "Set created successfully",
    });

    // redirect to the set list page
    navigate(ROUTES.SETS);
  };

  // handle set creation
  const handleUpdateSet = async ({ setId, setData }: any) => {
    const response = await updateSet(setId, setData);

    if (!response || response.status !== 200) {
      // check slug duplication

      if (response?.status === 409) {
        notify({
          type: "error",
          message: "Set Slug already exists",
        });
      } else {
        notify({
          type: "error",
          message: "Error updating Set",
        });
      }

      return;
    }

    notify({
      type: "success",
      message: "Set updated successfully",
    });

    // redirect to the set list page
    navigate(ROUTES.SETS);
  };

  return (
    <div className="w-full h-full">
      {loading && <Loader pageLoader />}

      {!loading && error && <Error message={error} />}

      {!loading && !error && (
        <div className="w-[95%] mx-auto ">
          <div className="w-full mx-auto">
            <h1 className="text-2xl font-bold text-primary">
              {isEditMode ? `Edit Set: ${set?.internalName}` : "Create Set"}
            </h1>
          </div>

          <div className="w-full block  mx-auto my-10 pb-20">
            <CreateUpdateSetForm
              set={set}
              btnLoading={btnLoading}
              isEditMode={isEditMode}
              onFormSubmission={(obj: any) => {
                if (isEditMode) {
                  handleUpdateSet(obj);
                } else {
                  handleCreateSet(obj);
                }
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default SetFormPage;
